import React, { useState, useEffect, useMemo, useRef } from 'react'; //, useMemo
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Form, Space, Row, Spin, Input, Select } from 'antd'; // message,, Typography
import styles from './index.module.less';
import FormItem from 'common/FormItem';
//import CustomButton from '@/common/CustomButton';
import { history } from '@/app/history';
import {
  create_bu_master,
  get_all_users,
  get_admin_sbus
} from '../../../../redux/slice';
import { debounce } from 'lodash';
import FormData from 'form-data';
import { useParams, useLocation } from 'react-router-dom';
import LocalStorage from 'utilities/localStorage';

//const { TextArea } = Input;
const { Option } = Select;

function CreateBuMsterFlow() {
  TabTitle('Gift Register - Create New Delegator Flow');

  const params = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get('mode');
  const isEditMode = mode === 'edit';

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const [formValues, setFormValues] = useState({});
  const [allUsersSearch, setAllUsersSearch] = useState('');
  const [allSbuSearch, setAllSbuSearch] = useState('');
  const {
    get_all_usersLoading,
    all_users_List,
    create_bu_masterLoading,
    //get_admin_sbusLoading,
    admin_sbusList
  } = useSelector((state) => state.admin);
  // console.log('all_users_List', all_users_List);
  // console.log('Please select the SBU from the list below@@@@@@@@@@@@', admin_sbusList);

  // Get record from localStorage for edit mode (memoized to prevent unnecessary re-renders)
  const buRecord = useMemo(() => {
    return isEditMode ? LocalStorage.getItem('bu_record') : null;
  }, [isEditMode]);

  useEffect(() => {
    const payload = {
      page: 1,
      per_page: 1000
    };
    if (allUsersSearch) payload['search'] = allUsersSearch;
    dispatch(get_all_users(payload));
  }, [allUsersSearch]);

  useEffect(() => {
    const payload = {
      page: 1,
      per_page: 1000
    };
    if (allSbuSearch) payload['search'] = allSbuSearch;
    dispatch(get_admin_sbus(payload));
  }, [allSbuSearch, dispatch]);

  // Get initial values for edit mode
  const initialValues = useMemo(() => {
    if (isEditMode && buRecord) {
      const sbuId = buRecord?.SbuId || buRecord?.sbuId || null;
      return {
        buName: buRecord?.buName || '',
        userId: buRecord?.buHeadId || '',
        SbuId: sbuId || ''
      };
    }
    return {};
  }, [isEditMode, buRecord]);

  // Track if we've already set the form values to prevent resetting on every render
  const hasSetFormValues = useRef(false);

  // Set form values when record is available (fallback for when initialValues might not work)
  useEffect(() => {
    if (
      isEditMode &&
      buRecord &&
      Object.keys(initialValues).length > 0 &&
      !hasSetFormValues.current
    ) {
      // Set form values only once - this ensures values are set even if initialValues didn't work
      form.setFieldsValue(initialValues);
      hasSetFormValues.current = true;
    }

    // Reset the flag when switching out of edit mode
    if (!isEditMode) {
      hasSetFormValues.current = false;
    }
  }, [isEditMode, buRecord, initialValues, form]);

  const debounceFetcherUserId = useMemo(() => {
    const loadOptions = (allUsersSearch) => {
      setAllUsersSearch(allUsersSearch);
    };
    return debounce(loadOptions, 400);
  }, []);

  const debounceFetcherSbuId = useMemo(() => {
    const loadOptions = (allSbuSearch) => {
      setAllSbuSearch(allSbuSearch);
    };
    return debounce(loadOptions, 400);
  }, []);

  const handleFormDataOnChange = (slug, value) => {
    console.log('slug,value:', slug, value);

    setFormValues({
      ...formValues,
      [slug]: value
    });
  };

  const onFinish = (values) => {
    let formdata = new FormData();
    formdata.append(
      'buName',
      values?.buName === undefined ? '' : values?.buName
    );

    formdata.append(
      'buHeadId',
      values?.userId === undefined ? '' : values?.userId
    );
    //formdata.append('isActive', true);
    // formdata.append(
    //   'sbgName',
    //   values?.sbgName === undefined ? '' : values?.sbgName
    // );
    formdata.append('SbuId', values?.SbuId === undefined ? '' : values?.SbuId);

    // Add ID for edit mode
    if (isEditMode && params?.id) {
      formdata.append('id', params.id);
    }

    dispatch(create_bu_master(formdata)).then(function (response) {
      if (response?.payload?.success) {
        console.log(response);
        history.push('/bu-master-flow');
      }
    });
  };

  return (
    <CustomLayout>
      <Spin spinning={get_all_usersLoading}>
        <div style={{ marginTop: '50px' }}>
          <Row className={`${styles.row_container_setting}`}>
            <div className={`${styles.gift_container}`}>
              <div className={`${styles.myGift_title_setting}`}>
                {isEditMode ? 'Edit BU' : 'Add new BU'}
              </div>
            </div>
          </Row>{' '}
          <div className={`${styles.container}`}>
            <div className={`${styles.cardContainer}`}>
              <Card className={`${styles.cardStyles_Container}`}>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className={`${styles.formstyles}`}
                  initialValues={initialValues}
                >
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Enter the BU full name
                          </div>
                        }
                        name="buName"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Input
                          className={`${styles.margin_Top}`}
                          allowClear
                          placeholder="Enter the BU full name"
                          onChange={(e) =>
                            handleFormDataOnChange('buName', e.target.value)
                          }
                        />
                        {/* <Select
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          showSearch
                          allowClear={true}
                          optionFilterProp="children"
                          placeholder="Select delegator"
                          onSearch={debounceFetcherAllUsers}
                          onChange={(value) =>
                            handleFormDataOnChange('delegatorId', value)
                          }
                          filterOption={(input, option) => {
                            return (
                              option.key
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.title
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                        >
                          {all_users_List?.map((item, index) => (
                            <Option
                              title={item?.givenName}
                              key={index}
                              value={item?.id}
                            >
                              <span
                                style={{
                                  fontSize: '12px',
                                  textTransform: 'uppercase',
                                  fontFamily: 'SFProText Regular'
                                }}
                              >
                                <span style={{ marginLeft: '10px' }}>
                                  {item?.givenName} (
                                  <span style={{ textTransform: 'lowercase' }}>
                                    {item?.email}
                                  </span>
                                  )
                                </span>
                              </span>
                            </Option>
                          ))}
                        </Select> */}
                      </FormItem>
                    </div>
                  </Card>
                  {/* <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Enter the BU Code
                          </div>
                        }
                        name="buCode"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Input
                          className={`${styles.margin_Top}`}
                          allowClear
                          placeholder="Enter the BU code"
                          onChange={(e) =>
                            handleFormDataOnChange('buCode', e.target.value)
                          }
                        />
                      </FormItem>
                    </div>
                  </Card> */}
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Please select the BU Head from the list below
                          </div>
                        }
                        name="userId"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Select
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          showSearch
                          allowClear={true}
                          optionFilterProp="children"
                          placeholder="Select BU Head"
                          onSearch={debounceFetcherUserId}
                          onChange={(value) =>
                            handleFormDataOnChange('userId', value)
                          }
                          filterOption={(input, option) => {
                            return option?.children
                              ?.toString()
                              ?.toLowerCase()
                              ?.includes(input?.toLowerCase());
                          }}
                        >
                          {all_users_List?.map((item, index) => {
                            return (
                              <Option
                                // title={item?.givenName}
                                key={index}
                                value={item?.id}
                              >
                                {`${item?.givenName} (${item.email})`}
                                {/* <span
                                style={{
                                  fontSize: '12px',
                                  textTransform: 'uppercase',
                                  fontFamily: 'SFProText Regular'
                                }}
                              >
                                <span style={{ marginLeft: '10px' }}>
                                  {item?.givenName} {''} {item?.surname}(
                                  <span style={{ textTransform: 'lowercase' }}>
                                    {item?.email}
                                  </span>
                                  )
                                </span>
                              </span> */}
                              </Option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </div>
                  </Card>
                  {/*  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Enter the SBG full name
                          </div>
                        }
                        name="sbgName"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Input
                          className={`${styles.margin_Top}`}
                          allowClear
                          placeholder="Enter the SBG full name"
                          onChange={(e) =>
                            handleFormDataOnChange('sbgName', e.target.value)
                          }
                        />
                      </FormItem>
                    </div>
                  </Card> */}
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Please select the SBU from the list below
                          </div>
                        }
                        name="SbuId"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Select
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          showSearch
                          allowClear={true}
                          optionFilterProp="children"
                          placeholder="Select SBU"
                          onSearch={debounceFetcherSbuId}
                          onChange={(value) =>
                            handleFormDataOnChange('SbuId', value)
                          }
                          filterOption={(input, option) => {
                            return option?.children
                              ?.toString()
                              ?.toLowerCase()
                              ?.includes(input?.toLowerCase());
                          }}
                        >
                          {admin_sbusList?.map((item, index) => {
                            return (
                              <Option
                                title={item?.name}
                                key={index}
                                value={item?.id}
                              >
                                {' '}
                                {`${item?.name}`}
                              </Option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </div>
                  </Card>
                  <div style={{ marginTop: '20px' }}>
                    <FormItem>
                      <Space
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          justifyItems: ' center'
                        }}
                      >
                        <Button
                          loading={create_bu_masterLoading}
                          className={`${styles.ExceptionalApproval_button}`}
                          htmlType="submit"
                          size="small"
                        >
                          Save
                        </Button>

                        <Button
                          className={`${styles.cancel_rejectModal_button}`}
                          size="small"
                          onClick={() => history.push('/bu-master-flow')}
                        >
                          Cancel
                        </Button>
                      </Space>
                    </FormItem>
                  </div>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </Spin>
    </CustomLayout>
  );
}
export default CreateBuMsterFlow;
